import React from "react"
import { createPortal } from "react-dom"
import { GatsbyImage } from "gatsby-plugin-image"
import { ILink, INavigationBar } from "../../../../gatsby-graphql"
import { Button, CloseButton } from "../../../ui"
import { ButtonType } from "../../../ui/button/button-elements"
import {
  ButtonsWrapper,
  LogoWrapper,
  MenuItems,
  MenuLink,
  MenuOverlay,
  MenuWrapper,
  SubmenuLink,
} from "./mobile-menu-elements"

interface MobileMenuProps {
  data: INavigationBar
  closeMenu: () => void
}

const MobileMenu = ({ closeMenu, data }: MobileMenuProps) => {
  const root = document.getElementsByTagName("body")[0]
  const logo = data.logo?.localFile?.childImageSharp?.gatsbyImageData

  return createPortal(
    <MenuOverlay>
      <MenuWrapper>
        <CloseButton onClose={closeMenu} />
        {logo && (
          <LogoWrapper>
            <GatsbyImage image={logo} alt="logo" />
          </LogoWrapper>
        )}
        <MenuItems>
          {data.mainMenu?.map((item, index) => {
            if (!item || !item.link) return null;
            return (
              <div key={index}>
                <MenuLink link={item.link}/>
                {item.subLinks?.map(
                  (subLink, index) => subLink && <SubmenuLink link={subLink} key={subLink.slug}/>
                )}
              </div>
            )
          })}
        </MenuItems>
        {data.buttons && data.buttons.length > 0 && (
          <ButtonsWrapper>
            {data.buttons.map((button, index) => (
              <Button
                link={button?.link as ILink}
                type={button?.type as ButtonType}
                textTransform="uppercase"
                key={index}
              />
            ))}
          </ButtonsWrapper>
        )}
      </MenuWrapper>
    </MenuOverlay>,
    root
  )
}

export default MobileMenu
